var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_408_1762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4066 2H7.74726C6.48821 2 5.28073 2.50561 4.39045 3.40561C3.50017 4.3056 3.00001 5.52626 3.00001 6.79905V32.394C2.99891 32.6758 3.0715 32.953 3.21044 33.1974C3.34938 33.4418 3.54974 33.6447 3.79122 33.7857C4.03178 33.9261 4.30466 34 4.58243 34C4.8602 34 5.13308 33.9261 5.37364 33.7857L14.0769 28.6987L22.7802 33.7857C23.0214 33.9239 23.2942 33.9956 23.5714 33.9936C23.8486 33.9956 24.1215 33.9239 24.3626 33.7857C24.6041 33.6447 24.8045 33.4418 24.9434 33.1974C25.0823 32.953 25.1549 32.6758 25.1538 32.394V6.79905C25.1538 5.52626 24.6537 4.3056 23.7634 3.40561C22.8731 2.50561 21.6656 2 20.4066 2ZM21.989 29.6265L14.8681 25.4673C14.6276 25.3269 14.3547 25.253 14.0769 25.253C13.7992 25.253 13.5263 25.3269 13.2857 25.4673L6.16484 29.6265V6.79905C6.16484 6.37478 6.33156 5.9679 6.62832 5.6679C6.92508 5.3679 7.32758 5.19936 7.74726 5.19936H20.4066C20.8263 5.19936 21.2288 5.3679 21.5255 5.6679C21.8223 5.9679 21.989 6.37478 21.989 6.79905V29.6265Z",
    fill: "#121314"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_408_1762",
    x: 1,
    y: 0,
    width: 26.1538,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.631373 0 0 0 0 0.482353 0 0 0 0 0.713726 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_408_1762"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_408_1762",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkDefault);
export default __webpack_public_path__ + "static/media/bookmark-default.88d86635d1ad60092ddded6ba4ba6b41.svg";
export { ForwardRef as ReactComponent };